<template>
  <div id="main w-full">
    <!-- <div id="nav">
      <nav>
        <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link>
      </nav>
    </div> -->
    <main>
      <!-- <div class="temp-page w-100">
        <div class="container h-100 d-flex align-items-center justify-items-centre">
          <h1 class="text">
            CLOANS <br>
            DESIGNS
          </h1>
        </div>
      </div> -->
      <router-view />
    </main>
  </div>
</template>

<style>

:root {
  /* --primary-color: #DAB8A2;
  --secondary-color: #402D22;
  --tertiary-color: #8D664E;
  --light-color: #BE9883;
  --dark-color: #0E0D0E; */
  /* --bg-opacity */
  --primary-color: rgba(218, 184, 161, 1);    
  --secondary-color: rgba(63, 45, 33, 1);
  --tertiary-color: rgba(140, 102, 77, 1);
  --light-color: rgba(189, 151, 131, 1);
  --dark-color: rgba(14, 13, 14, 1);
}

/* Color Theme Swatches in Hex */
.Copy-of-Brown-1-hex { color: #DAB8A2; }
.Copy-of-Brown-2-hex { color: #402D22; }
.Copy-of-Brown-3-hex { color: #8D664E; }
.Copy-of-Brown-4-hex { color: #BE9883; }
.Copy-of-Brown-5-hex { color: #0E0D0E; }

/* Color Theme Swatches in RGBA */
.Copy-of-Brown-1-rgba { color: rgba(218, 184, 161, 1); }
.Copy-of-Brown-2-rgba { color: rgba(63, 45, 33, 1); }
.Copy-of-Brown-3-rgba { color: rgba(140, 102, 77, 1); }
.Copy-of-Brown-4-rgba { color: rgba(189, 151, 131, 1); }
.Copy-of-Brown-5-rgba { color: rgba(14, 13, 14, 1); }

/* Color Theme Swatches in HSLA */
.Copy-of-Brown-1-hsla { color: hsla(23, 43, 74, 1); }
.Copy-of-Brown-2-hsla { color: hsla(22, 30, 19, 1); }
.Copy-of-Brown-3-hsla { color: hsla(22, 28, 42, 1); }
.Copy-of-Brown-4-hsla { color: hsla(21, 31, 62, 1); }
.Copy-of-Brown-5-hsla { color: hsla(300, 3, 5, 1); }

* {
  font-family: 'Roboto Slab', serif;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
}

.bg-primary {
  background-color: var(--primary-color) !important;
  /* --primary-color: rgba(218, 184, 161, 1);   */
}

.color-primary {
  color: var(--primary-color) !important;
}

.bg-secondary {
  background-color: var(--secondary-color) !important;  
  /* --secondary-color: rgba(63, 45, 33, 1); */
}

.color-secondary {
  color: var(--secondary-color) !important;
}

.bg-tertiary {
  background-color: var(--tertiary-color) !important;
  /* --tertiary-color: rgba(140, 102, 77, 1); */
}

.color-tertiary {
  color: var(--tertiary-color) !important;
}

.bg-light {
  background-color: var(--light-color) !important;
  /* --light-color: rgba(189, 151, 131, 1); */
}

.color-light {
  color: var(--light-color) !important;
}

.bg-dark {
  background-color: var(--dark-color) !important;
  /* --dark-color: rgba(14, 13, 14, 1); */
}

.color-dark {
  color: var(--dark-color) !important;
}

a {
  display: inline-block;
}

ul {
  list-style: none;
}

/* .temp-page {
  background: rgba(0, 0, 0, .5)  url('./assets/hotel/t.jpg') no-repeat center center / cover ;
  background-blend-mode: overlay;
  height: 100vh;
  width: 100vw;
  color: white;
}

.text {
  font-size: 3.9rem;
  font-weight: 700;
} */

/* .container */

/* #nav {
  padding: 30px;
} */

/* #nav a {
  font-weight: bold;
  color: #2c3e50;
} */

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
